import { GetServerDataProps, PageProps } from 'gatsby'
import React, { useEffect } from 'react'
import { RealEstateDataPageComponent } from 'types'

interface Props {
  name: string
  development_id: string
}

const isBrowser = typeof window !== 'undefined'

const DevelopmentDetail = ({ development_id: developmentID, pageContext }: Props & PageProps) => {
  const { global_data, components } = pageContext as any

  const body = isBrowser ? document.body : null
  const loader = isBrowser ? document.getElementById('preloader') : null

  useEffect(() => {
    setTimeout(() => {
      loader?.classList.add('preloader-hide')
      setTimeout(() => {
        body?.classList.remove('preloader_active')
        body?.classList.add('preloader_ready')
      }, 450)
    }, 450)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return isBrowser ? (
    <div>
      {(components as RealEstateDataPageComponent[]).map(({ type, type_id, data }) => {
        let Component
        try {
          Component = require(`@components/${type}/${type_id}`).default
        } catch (e) {
          return null
        }
        return (
          <Component
            {...data}
            developmentID={developmentID}
            key={`${type}-${type_id}`}
            {...{ global_data }}
          />
        )
      })}
    </div>
  ) : null
}

export async function getServerData(props: GetServerDataProps) {
  const fetchDevelopment: any = async (category: string) =>
    await fetch(
      `${process.env.GATSBY_APISERVER}core/compartir/?client=${process.env.GATSBY_CLIENTID}&category=${category}&id=${props.params?.development_id}`,
    )

  try {
    const tokkoReponse = await fetchDevelopment('emprendimientos')
    const mediacoreReponse = await fetchDevelopment('emprendimientos_mediasite')

    if (!tokkoReponse.ok && !mediacoreReponse.ok) {
      throw new Error(`Response failed`)
    }

    const developmentTokko = await tokkoReponse.json()
    const developmentMediacore = await mediacoreReponse.json()

    const development = developmentTokko?.title ? developmentTokko : developmentMediacore

    return {
      props: {
        openGraph: {
          title: development.title,
          image: development.image,
          description: development.headline,
        },
      },
    }
  } catch (error) {
    console.log(error)
    return {
      status: 500,
      headers: {},
      props: {},
    }
  }
}

export default DevelopmentDetail

export { Head } from '@components/Head'
